<template>
  <div>
    <el-table :data="blockHeightTaskList" height="400" size="small" border>
      <el-table-column prop="id" width="140px" label="ID" fixed show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coinType"  label="币种" fixed>
        <template slot-scope="scope">{{
          scope.row.coinType
        }}</template>
      </el-table-column>
      <el-table-column prop="height"  label="高度" fixed>
        <template slot-scope="scope">
          <span>{{scope.row.height}}</span>
        </template>
      </el-table-column>
      <el-table-column width="140px" prop="executionStatus" label="执行状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.executionStatus==0">待执行</el-tag>
          <el-tag type="warning" v-else-if="scope.row.executionStatus==1">执行中</el-tag>
          <el-tag type="success" v-else-if="scope.row.executionStatus==2">已执行</el-tag>
          <el-tag type="danger" v-else>执行失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="140px" prop="executionTx" label="该高度处理的tx条数" show-overflow-tooltip>
        <template slot-scope="scope">
          <a >{{scope.row.executionTx}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180">
        <template slot-scope="scope">
          <span >{{scope.row.createTime}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="executionTime" label="执行时间" width="180">
        <template slot-scope="scope">
          <span >{{ scope.row.executionTime}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述（异常，失败原因）" width="240" show-overflow-tooltip>
        <template slot-scope="scope">
          <span >{{ scope.row.description}}</span>
        </template>
      </el-table-column>
     <el-table-column prop="retryTimes" label="重试次数" width="100"></el-table-column>
    
      <el-table-column label="编辑" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDel(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="size"
      :total="totalCount"
      :page="page"
      @pageChanged="pageChanged"
    ></pagination>
    <update-dialog :val="userinfoDetail"  :page="page" :size="size" :height="height" :coinType="coinType" :executionStatus="executionStatus"></update-dialog>
  
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import updateDialog from '../updatedialog';

export default {
  name: 'UserList',
 props:['height','coinType','executionStatus'],
  data() {
    return {
      page:1,size:25,
    };
  },
  components: {
    Pagination,
    updateDialog
  },
  methods: {
    ...mapActions('blockHeightTask', ['delOne']),
    ...mapMutations('blockHeightTask', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    pageChanged(pagination) {
      this.page=pagination.page
      this.size=pagination.size
      this.$emit('refresh', pagination);
    },
    handleDel(row){
      console.log(row.id);
      this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delOne(row.id).then(res=>{
            if(res.code==0){
              this.$emit('refresh',{page:this.page,size:this.size,executionStatus:this.executionStatus})
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
   
  },
  computed: {
    ...mapGetters('blockHeightTask', ['userList',]),
    ...mapState('blockHeightTask', [
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible','blockHeightTaskList'
    ])
  }
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
